import { Box, Container, Typography } from '@mui/material';

import { getOr } from '@/api/client';
import { RUTAS } from '@/api/rutas';
import { CarruselDeImagenes } from '@/components/CarruselDeImagenes';
import { MedirVisita } from '@/components/MedirVisita';
import type { Imagen } from '@/tipos';

import type { Route } from './+types/novedades';

export function meta(): Route.MetaDescriptors {
  return [
    { title: 'Novedades y Ofertas | CKING' },
    {
      name: 'description',
      content: 'Últimos ingresos y promociones de CKING: repuestos para motos.',
    },
    { tagName: 'link', rel: 'canonical', href: 'https://cking.com.ar/novedades' },
  ];
}

export async function loader({ request }: Route.LoaderArgs) {
  const vacio = { images: [] as Imagen[] };

  const [novedades, ofertas] = await Promise.all([
    getOr<{ images: Imagen[] }>(RUTAS.imagenes.coleccionPublica('novedades'), vacio, {
      request,
      query: { limit: 50 },
    }),
    getOr<{ images: Imagen[] }>(RUTAS.imagenes.coleccionPublica('offers'), vacio, {
      request,
      query: { limit: 50 },
    }),
  ]);

  return { novedades: novedades.images, ofertas: ofertas.images };
}

function TituloDeSeccion({ children }: { children: string }) {
  return (
    <Typography
      variant="h4"
      component="h2"
      sx={{
        mt: 8,
        mb: 4,
        fontWeight: 700,
        textAlign: 'center',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          width: '60px',
          height: '3px',
          bottom: '-10px',
          left: '50%',
          backgroundColor: 'primary.main',
          transform: 'translateX(-50%)',
        },
      }}
    >
      {children}
    </Typography>
  );
}

export default function Novedades({ loaderData }: Route.ComponentProps) {
  return (
    <Box sx={{ py: 4, bgcolor: '#121212', minHeight: '100vh' }}>
      <MedirVisita path="/novedades" />

      <Container maxWidth="xl">
        <Typography
          variant="h3"
          component="h1"
          sx={{
            mb: 4,
            fontWeight: 700,
            textAlign: 'center',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              width: '60px',
              height: '3px',
              bottom: '-10px',
              left: '50%',
              backgroundColor: 'primary.main',
              transform: 'translateX(-50%)',
            },
          }}
        >
          Sección Principal de Novedades
        </Typography>

        <TituloDeSeccion>Novedades (Últimos Ingresos)</TituloDeSeccion>
        <CarruselDeImagenes
          imagenes={loaderData.novedades}
          automatico
          vacio="No hay novedades disponibles"
        />

        <TituloDeSeccion>Promociones Exclusivas</TituloDeSeccion>
        <CarruselDeImagenes imagenes={loaderData.ofertas} vacio="No hay ofertas disponibles" />
      </Container>
    </Box>
  );
}
